export default "__VITE_ASSET__FJ04nukV__"